module.exports = __webpack_public_path__ + "static/favicon-b030d240ca4c95421dcb200061f5f851.png";